module.exports = ".chipestado {\n  color: white;\n  font-size: 11px;\n  min-height: 24px;\n  padding: 4px 8px;\n}"